
import PIXI from '../GameEngine/pixi.js';
import Button from './ButtonSolid.js'
export default class ChatSelection extends PIXI.Container {
    constructor(title, ...arg) {
        super(...arg);
        this.title = title||"";
        this.stageWidth = 550;
        this.stageHeight = 400;
        this.onSelect = function (value) { };


        this.interactive = true;
        this.on('pointerdown', this.close_onClick.bind(this));

        //popupBackground
        var popupBackground = new PIXI.Graphics();
        popupBackground.beginFill(0x000000);
        popupBackground.drawRect(-500, -500, 1000, 1000);
        popupBackground.alpha = 0.1;
        this.addChild(popupBackground);

        this.container = new PIXI.Container();
        this.addChild(this.container);



        // this.color = color|| 0x479ACE;// or 0x479ACE or 0xC03500
        this.color = 0x479ACE;// or 0x479ACE or 0xC03500
        //titleBox
        var titleBox = new PIXI.Graphics();
        titleBox.beginFill(this.color);
        titleBox.drawRoundedRect(0, 0, 500, 80, 10);
        // titleBox.beginFill(0x333333);
        // titleBox.drawRoundedRect(0, 400, 550, 80, 10);
        this.container.addChild(titleBox);


        //background
        var graphics = new PIXI.Graphics();
        graphics.beginFill(0x333333);
        graphics.drawRect(0, 50, 500, 350);
        this.container.addChild(graphics);







        //create title

        let styleTitle = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 30 * 2,
            fill: '#FFFFFF',
            align: 'center'
        });
        let styleLarge = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 50 * 2,
            fill: '#FFFFFF'
        });
        let styleNormal = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 20 * 2,
            fill: '#FFFFFF'
        });
        let styleSmall = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 12 * 2,
            fill: '#FFFFFF'
        });

        //textTitle
        this.textTitle = new PIXI.Text(this.title, styleTitle);
        this.textTitle.x = 220;
        this.textTitle.y = 7;
        this.textTitle.anchor.set(0.5, 0);
        this.textTitle.scale.set(0.5);
        this.container.addChild(this.textTitle);



        //point background
        var pointCircle = new PIXI.Graphics();
        pointCircle.beginFill(0xC03500);
        pointCircle.lineStyle(0, 0xFFFFFF, 1);
        pointCircle.drawRoundedRect(410, 5, 80, 40, 10);
        this.container.addChild(pointCircle);

        //textCorner
        this.textHandScore = new PIXI.Text("X", styleTitle);
        this.textHandScore.x = 450;
        this.textHandScore.y = 7;
        this.textHandScore.anchor.set(0.5, 0);
        this.textHandScore.scale.set(0.5);
        this.container.addChild(this.textHandScore);

        this.chatPhrases = ['Hello', 'Good Game', 'Nice Hand', 'Ouch'];
        for (let i = 0; i < this.chatPhrases.length; i++) {
            let chatPhrase = this.chatPhrases[i];

            //button
            let btnPhrase = new Button(chatPhrase, 0x479ACE);
            btnPhrase.x = 140;
            btnPhrase.y =80+(i*80);
            btnPhrase.interactive = true;
            btnPhrase.on('pointerdown', this.btnPhrase_onClick.bind(this,chatPhrase));
            this.container.addChild(btnPhrase);
        }



        //center content
        this.container.x = 0 - (this.container.width / 2);
        this.container.y = 0 - (this.container.height / 2);


    }
    btnPhrase_onClick(value,event){
        if (this.onSelect) {
            this.onSelect(value);
        }
        this.visible = false;
        event.stopPropagation();
    }

    close_onClick() {
        this.visible = false;
        this.parent.isDirty = true;
    }


}